module.exports = __webpack_public_path__ + "static/img/collection_onboarding.8970c348.png";